import { render, staticRenderFns } from "./planos.vue?vue&type=template&id=26bd8c0f&scoped=true"
import script from "./planos.vue?vue&type=script&lang=js"
export * from "./planos.vue?vue&type=script&lang=js"
import style0 from "./planos.vue?vue&type=style&index=0&id=26bd8c0f&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "26bd8c0f",
  null
  
)

export default component.exports